export const validateEmail = (email) => {
  const defaultMaxEmailLength = 254;

  const forbiddenChars = /[åäöéàèê]/i;

  if (forbiddenChars.test(email)) return false;

  const emailUserUtf8Part =
    /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~.\u00A1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;

  /*Quoted email local part validation requires control characters as per RFC 5322 */
  const quotedEmailUserUtf8 =
    /* eslint-disable-next-line no-control-regex */
    /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;

  const domainPattern =
    /^[\p{L}\p{N}](?:[\p{L}\p{N}-]{0,61}[\p{L}\p{N}])?(\.[\p{L}\p{N}](?:[\p{L}\p{N}-]{0,61}[\p{L}\p{N}])?)*\.[\p{L}]{2,}$/u;

  if (typeof email !== "string" || email.length > defaultMaxEmailLength)
    return false;

  const parts = email.split("@");

  if (parts.length !== 2) return false;

  const [local, domain] = parts;

  if (!domainPattern.test(domain)) return false;

  const isUnquotedValid = emailUserUtf8Part.test(local);
  const isQuoted = local.startsWith('"') && local.endsWith('"');
  const quotedContent = local.slice(1, -1);
  const isQuotedValid = quotedEmailUserUtf8.test(quotedContent);

  const isLocalValid = isUnquotedValid || (isQuoted && isQuotedValid);
  if (local.length > 64 || !isLocalValid) return false;

  return true;
};
